"use client";
import {
  ripple_default
} from "./chunk-MRKSP4U5.mjs";
import {
  useRipple
} from "./chunk-A6KBW6T5.mjs";
export {
  ripple_default as Ripple,
  useRipple
};
